import { Component } from '@angular/core';

@Component({
  selector: 'naas-help-guide',
  templateUrl: './help_guides.component.html',
  styleUrls: ['./help_guides.component.scss'],
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class Help_GuideComponent {}
